import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=f251089a&scoped=true"
var script = {}
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=f251089a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f251089a",
  null
  
)

export default component.exports